import {$, $e, $each} from "../../../core/cfjs/index.js";
import {$val} from "../helper.js";

const regEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

function getCleanlinessFieldId(service) {
    if (service === 'moveout') return 'moveCleanliness'
    if (service === 'commercial') return 'commTraffic'
    return 'cleanliness'
}

const ADDONS_FIELDS = {
    vacation: [
        {id: 'vacationDeep', type: 'bool'},
        {id: 'hotTub', type: 'bool'},
        {id: 'bbqGrill', type: 'number'},
        {id: 'expressArrival', type: 'bool'},
        {id: 'qaInspector', type: 'bool'},
        {id: 'laundry', type: 'string'},
        {id: 'laundryGuests', type: 'number'},
    ],

    residential: [
        {id: 'ovenInside', type: 'bool'},
        {id: 'fridgeInside', type: 'bool'},
        {id: 'windowsInterior', type: 'number'},
        {id: 'windowTracks', type: 'number'},
        {id: 'blindsDetailed', type: 'number'},
        {id: 'cabinetsInside', type: 'bool'},
        {id: 'baseboardsDetailed', type: 'bool'},
        {id: 'petsHair', type: 'bool'},
        {id: 'garageCleaning', type: 'bool'},
        {id: 'wash_dry_laundry', type: 'number'},
        {id: 'balconyPatio', type: 'bool'},
        {id: 'bedMaking', type: 'number'},
    ],
    postconstruction: [
        {id: 'constructionFloors', type: 'string'},
        {id: 'floorProtection', type: 'string'},
        {id: 'windowCleaning', type: 'string'},
        {id: 'windowPanes', type: 'number'},
        {id: 'protectiveFilm', type: 'string'},
    ],

    commercial: [
        {id: 'commExteriorWindows', type: 'number'},
        {id: 'commCarpetSqft', type: 'number'},
        {id: 'commFloorSqft', type: 'number'},
        {id: 'commNight8', type: 'bool'},
    ],

    moveout: [
        {id: 'windowsInterior', type: 'number'},
        {id: 'windowTracks', type: 'number'},
        {id: 'blindsDetailed', type: 'number'},
        {id: 'windowScreens', type: 'number'},
    ],
};


function getAddonValue(root, {id, type, defaultVal}) {
    const el = $(`#${id}`, root) || $(`[name="booking_${id}"]`, root);
    if (!el) return type === 'bool' ? false : (defaultVal ?? (type === 'string' ? '' : 0));
    switch (type) {
        case 'bool':
            return !!el.checked;
        case 'number':
            return Number(el.value || 0);
        case 'string':
            return (el.value ?? defaultVal ?? '');
        default:
            return el.value;
    }
}

/* =========================
   collectForm
   ========================= */
export function collectForm(root = document) {
    const $getV = (q) => $val(q, '', root)

    const num = (id) => {
        const v = $getV(id);
        return v ? Number(v) : null;
    };

    /* ---------- Basic fields ---------- */
    const service = $getV('service');
    let propertyType = $getV('propertyType');

    const br = num('br');
    const ba = num('ba');
    const sqft = num('sqft');
    /* ---------- Step 2 ---------- */
    const zip = $getV('booking_zip');

    /* ---------- Step 3 / service details ---------- */
    const cleanliness = service ? $getV(getCleanlinessFieldId(service)) : $getV('cleanliness');
    const cleaningLevel = $getV('cleaningLevel');
    const resFrequency = $getV('resFrequency');
    const resPreferredDay = $getV('resPreferredDay');
    const commFrequency = $getV('commFrequency');


    /* ---------- Step 6 ---------- */
    const contact = {
        name: $getV('name').trim(),
        phone: $getV('phone').trim(),
        email: $getV('email').trim(),
        terms: !!$('#terms-booking').checked,
        termsContactSms: !!$('#modal-terms-sms').checked
    };

    /* ---------- Add-ons ---------- */
    const addons = {};
    const addonFields = ADDONS_FIELDS[service] || [];
    for (const field of addonFields) {
        const value = getAddonValue(root, field);
        if (field.type === 'string' && value === '') continue;
        addons[field.id] = value;
    }

    if (service === 'residential') {
        if (cleaningLevel) addons.cleaningLevel = cleaningLevel;
        if (resFrequency) addons.resFrequency = resFrequency;
        if (resPreferredDay) addons.resPreferredDay = resPreferredDay;
    }

    if (service === 'commercial' && commFrequency) {
        addons.commFrequency = commFrequency;
        propertyType = $val('commercialType');
        if(propertyType === 'other'){
            propertyType = $val('commercialTypeOther');
        }
    }

    const constructionFloors = $getV('constructionFloors');
    if (service === 'postconstruction') {
        if (constructionFloors) addons.constructionFloors = constructionFloors;
    }

    if (service === 'vacation') {
        addons.laundry = {
            guests: Number($getV('laundryGuests', 0)),
            value: $getV('booking_laundry'),
        };
    }

    /* ---------- Return ---------- */

    const coupon = $val('booking_coupon')
    return {
        service,
        propertyType,
        br,
        ba,
        sqft,
        coupon,
        cleanliness,
        cleaningLevel,
        location: {zip},
        contact,
        addons,
    };
}


/* =========================
   Visibility rules (step 1) — table-driven
   ========================= */
const VIS = {
    default: {sqft: false, br: true, ba: true, prop: false, clean: false, resDeep: false},
    vacation: {sqft: true, br: true, ba: true, prop: true, clean: false, resDeep: false},
    residential: {sqft: true, br: true, ba: true, prop: true, clean: true, resDeep: true},
    moveout: {sqft: true, br: true, ba: true, prop: true, clean: true, resDeep: false},
    postconstruction: {sqft: true, br: false, ba: false, prop: true, clean: false, resDeep: false},
    commercial: {sqft: true, br: false, ba: false, prop: false, clean: true, resDeep: false},
};

export function validateVisibilityByService(service, root = d) {
    const resDeepWrap = $('#resDeepWrap');
    const sqftWrap = $('#sqftWrap');
    const propTypeWrap = $('#propTypeWrap');
    const constructionFloorsWrap = $('#constructionFloorsWrap');

    const brLabel = $('label[for="br"]') || $('#br')?.closest('label');
    const baLabel = $('label[for="ba"]') || $('#ba')?.closest('label');
    const roomsInfo = $('#roomsInfo');

    const showEl = (el, on = true) => el && el.classList.toggle('hidden', !on);

    const cfg = VIS[service] || VIS.default;


    showEl(sqftWrap, cfg.sqft);
    showEl(brLabel, cfg.br);
    showEl(baLabel, cfg.ba);
    showEl(propTypeWrap, cfg.prop);
    showEl(resDeepWrap, cfg.resDeep);
    showEl(constructionFloorsWrap, service === 'postconstruction');

    const showRooms = !!(cfg.br || cfg.ba);
    showEl(roomsInfo, showRooms);
}

/* =========================
   validateInput → { fieldId: message }
   ========================= */
export function validateInput(data, {forBooking = false} = {}) {
    const errors = {};

    const service = data.service;

    if (!service) {
        return {service: 'Service is required'};
    }

    /* ---------- Service flags ---------- */
    const isResidential = service === 'residential';
    const isVacation = service === 'vacation';
    const isCommercial = service === 'commercial';
    const isMoveout = service === 'moveout';

    const requiresSqft = [
        'vacation',
        'residential',
        'moveout',
        'postconstruction',
        'commercial',
    ].includes(service);

    const requiresBedrooms = isResidential || isVacation || isMoveout;
    const requiresBathrooms = isResidential || isMoveout;

    /* ---------- Property ---------- */
    if (!isCommercial && !data.propertyType) {
        errors.propertyType = 'Property Type is required';
    }

    /* ---------- Rooms ---------- */
    if (requiresBedrooms && data.br == null) {
        errors.br = 'Bedrooms are required';
    }

    if (requiresBathrooms && data.ba == null) {
        errors.ba = 'Bathrooms are required';
    }

    /* ---------- Square footage ---------- */
    if (requiresSqft && (!data.sqft || Number(data.sqft) <= 0)) {
        errors.sqft = 'Square footage is required';
    }

    /* ---------- Cleanliness / Frequency ---------- */
    if ((isResidential || isMoveout) && !data.cleanliness) {
        errors.cleanliness = 'Please select cleanliness/condition';
    }

    if (isResidential) {
        const level = data.cleaningLevel || data.addons?.cleaningLevel;
        if (!level) {
            errors.cleaningLevel = 'Please select a cleaning level';
        } else if (level !== 'deep_onetime' && !data.addons?.resFrequency) {
            errors.resFrequency = 'Please choose frequency';
        }
    }

    if (isCommercial) {
        if (!data.cleanliness) {
            errors.cleanliness = 'Please select traffic level';
        }
        if (!data.addons?.commFrequency) {
            errors.commFrequency = 'Please choose frequency (per week)';
        }
    }

    if (service === 'postconstruction') {
        if (!data.addons?.constructionFloors) {
            errors.constructionFloors = 'Please select number of floors';
        }
        if (!data.addons?.floorProtection) {
            errors.floorProtection = 'Please select floor protection option';
        }
        const windowCleaning = data.addons?.windowCleaning || 'none';
        if (!windowCleaning) {
            errors.windowCleaning = 'Please select window cleaning option';
        }
        if (windowCleaning === 'interior' || windowCleaning === 'interior_exterior') {
            const panes = Number(data.addons?.windowPanes || 0);
            if (!panes || panes <= 0) {
                errors.windowPanes = 'Number of panes is required';
            }
            if (!data.addons?.protectiveFilm) {
                errors.protectiveFilm = 'Please select protective film option';
            }
        }
    }

    /* ---------- Laundry ---------- */

    // console.log(data.addons)
    // if (isVacation && data.addons.laundry) {
    //     const beds = data.addons.laundryUnit.beds;
    //     if (
    //         typeof beds === 'number' &&
    //         typeof data.br === 'number' &&
    //         beds < data.br
    //     ) {
    //         errors.laundryBeds = 'Laundry bed sets cannot be less than BR';
    //     }
    // }

    /* ---------- Booking ---------- */

    if (forBooking) {
        const {name, phone, email, terms, termsContactSms} = data.contact || {};

        if (!name) errors.name = 'Full name is required';

        if (!phone) {
            errors.phone = 'Phone is required';
        }else if (phone.length < 10) {
            errors.phone = 'Enter a valid phone';
        }

        if (!email) {
            errors.email = 'Email is required';
        } else if (!regEmail.test(email)) {
            errors.email = 'Enter a valid email';
        }

        if (!terms) errors.terms = 'You must agree.';
        if (!termsContactSms) errors.termsContactSms = 'You must agree.';
    }

    return errors;
}


export function attachFieldValidationOnBlur(
    root,
    fieldIds,
    collectFn,
    validateFn,
    validateOptions,
    showErrorsFn
) {


    $each(fieldIds, (id) => {
        const el = $(`#${id}`, root);
        if (!el) return;

        const isCheckbox = el.type === "checkbox";
        const blurEvent = isCheckbox ? "change" : "blur";
        const inputEvent = isCheckbox ? "change" : "input";


        $e(el, blurEvent, () => {
            const data = collectFn(root);
            const errs = validateFn(data, validateOptions);

            const relevantErrs = {};
            if (errs[id]) {
                relevantErrs[id] = errs[id];
                showErrorsFn(relevantErrs, root);
            } else {
                clearFieldError(root, id);
            }
        });


        $e(el, inputEvent, () => {
            const data = collectFn(root);
            const errs = validateFn(data, validateOptions);

            if (!errs[id]) {
                clearFieldError(root, id);
            }
        });
    });
}


function clearFieldError(root, id) {
    const errEl = $(`.error-msg[data-error-for="${id}"]`, root);
    const input = $(`#${id}`, root);
    if (errEl) {
        errEl.textContent = "";
        errEl.classList.remove("shown");
    }
    if (input) input.setAttribute("aria-invalid", "false");
}

/* =========================
   validateContactForm(root)
   ========================= */
export function validateContactForm(root = document) {
    const errors = {};

    const _$ = q => $(q, root)

    const name = $val('name').trim();
    const phone = $val('phone').trim();
    const email = $val('email').trim();

    const terms =
        _$('input[name="booking_terms"]')?.checked ||
        _$('input[name="terms"]')?.checked ||
        false;

    const termsSMS = _$('input[name="terms-sms"]')?.checked || false;

    /* ---------- Name ---------- */

    if (!name) {
        errors.name = 'Full name is required';
    } else if (name.length < 2 || !/^[a-zA-Zа-яА-ЯёЁ -]+$/.test(name)) {
        errors.name = 'Enter a valid name';
    }

    /* ---------- Phone ---------- */

    if (!phone) {
        errors.phone = 'Phone is required';
    }else if (phone.length < 10) {
        errors.phone = 'Enter a valid phone';
    }

    /* ---------- Email ---------- */

    if (!email) {
        errors.email = 'Email is required';
    } else if (!regEmail.test(email)) {
        errors.email = 'Enter a valid email';
    }

    /* ---------- Terms ---------- */

    if (!terms) {
        errors.terms = 'You must agree to our terms.';
    }

    if (!termsSMS) {
        errors.termsSMS = 'You must agree to our terms.';
    }

    return errors;
}
